import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=08951fc3&scoped=true"
import script from "./InfoDetails.vue?vue&type=script&lang=js"
export * from "./InfoDetails.vue?vue&type=script&lang=js"
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=08951fc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08951fc3",
  null
  
)

export default component.exports